<template>
  <svg width="15" height="15" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.3333 0.333374H1.66668C0.933344 0.333374 0.34001 0.933374 0.34001 1.66671L0.333344 13.6667L3.00001 11H12.3333C13.0667 11 13.6667 10.4 13.6667 9.66671V1.66671C13.6667 0.933374 13.0667 0.333374 12.3333 0.333374ZM3.00001 5.00004H11V6.33337H3.00001V5.00004ZM8.33334 8.33337H3.00001V7.00004H8.33334V8.33337ZM11 4.33337H3.00001V3.00004H11V4.33337Z" fill="#333333"/>
  </svg>
</template>
<script>
  export default {
    name: 'IconRequestQuote'
  }
</script>